// extracted by mini-css-extract-plugin
export default {"pageLoadingWrapper":"appStyles_pageLoadingWrapper__u1oBf","toastContainer":"appStyles_toastContainer__Chg-v"};